import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_GM_CAMPAIGNS, GET_GM_CAMPAIGNS_SUCCESS, GET_GM_CAMPAIGNS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getGmCampaigns({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/other-gm-prices/campaigns`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_GM_CAMPAIGNS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_GM_CAMPAIGNS_ERROR,
        payload: response?.response?.data?.message || response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_GM_CAMPAIGNS_ERROR, payload: error });
  }
}

export function* watchGetGmCampaigns() {
  yield takeEvery(GET_GM_CAMPAIGNS, getGmCampaigns);
}

function* getGmCampaignsSaga() {
  yield all([fork(watchGetGmCampaigns)]);
}

export default getGmCampaignsSaga;
